import React, { FunctionComponent } from 'react';
import { AdminApiConnectionCreation, AdminApiConnectionUpdate } from 'src/api';
import Hint from 'src/ui/atoms/hint';
import Section from 'src/ui/atoms/section';
import Translate from 'src/ui/atoms/translate';
import CopyInputGroup from 'src/ui/molecules/copy-input-group';
import { Modal, ModalContent, ModalFooter, ModalFooterButtons, ModalHeader } from 'src/ui/molecules/modal';

interface AddApiConnectionSuccessModalProps {
  onClose: () => void;
  createdApiConnection?: AdminApiConnectionCreation;
  editedApiConnection?: AdminApiConnectionUpdate;
}

const AddApiConnectionSuccessModal: FunctionComponent<AddApiConnectionSuccessModalProps> = ({
  createdApiConnection,
  editedApiConnection,
  onClose,
}) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate
          name={`${editedApiConnection ? 'editApiConnectionSuccessModal' : 'addApiConnectionSuccessModal'}.title`}
        />
      </ModalHeader>
      <ModalContent>
        <>
          <Section spacing="regular">
            <Hint variant="success">
              <Translate
                name={`${
                  editedApiConnection
                    ? 'editApiConnectionSuccessModal.successHintWithSecret'
                    : 'addApiConnectionSuccessModal.successHint'
                }`}
                as="span"
                args={[<strong>{editedApiConnection?.name || createdApiConnection?.name}</strong>]}
              />
            </Hint>
          </Section>
          <Section spacing="regular">
            <Section spacing="small">
              <CopyInputGroup
                valueToCopy={editedApiConnection?.clientId || createdApiConnection?.clientId}
                label={<Translate name="addApiConnectionSuccessModal.clientId" />}
                disabled
              />
            </Section>
            <CopyInputGroup
              valueToCopy={editedApiConnection?.clientSecret || createdApiConnection?.clientSecret}
              label={<Translate name="addApiConnectionSuccessModal.clientSecret" />}
              disabled
            />
          </Section>
          <Hint variant="warning">
            <div>
              <p>
                <Translate as="b" name="addApiConnectionSuccessModal.warningHintTitle" />
              </p>
              <Translate name="addApiConnectionSuccessModal.warningHintContent" />
            </div>
          </Hint>
        </>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          align="end"
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: onClose,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default AddApiConnectionSuccessModal;
